import axios from "axios";

export const SYSTEM_LOG_URL = "/SystemLog";

/** Belli Bir Kullanıcı İşlemi (Log) Listesini Elde Eder ... */
export function getSystemLogs(queryParams) {
  return axios.post(`${SYSTEM_LOG_URL}/GetSystemLogs`, queryParams);
}

/** Belli Bir Kullanıcı İşlemi Sırasında Oluşan Hatayı (Exception) Elde Eder ... */ 
export function getException(id) {
  return axios.get(`${SYSTEM_LOG_URL}/${id}`);
}